import './style.css';
import * as PIXI from 'pixi.js';
import { MinionsApp } from './game/App';

/** public/miniback.png — 캔버스 밖(safe-area 등)까지 동일 톤·이미지로 채움 */
if (typeof document !== 'undefined') {
  const b = import.meta.env.BASE_URL;
  const base = b.endsWith('/') ? b : `${b}/`;
  document.documentElement.style.setProperty('--minions-miniback-url', `url('${base}miniback.png')`);
}

/** PHP/임베드 페이지에 viewport 가 없으면 모바일이 데스크톱 폭(980px 등)으로 렌더 → 확대된 것처럼 보임 */
if (typeof document !== 'undefined' && !document.querySelector('meta[name="viewport"]')) {
  const m = document.createElement('meta');
  m.setAttribute('name', 'viewport');
  m.setAttribute(
    'content',
    'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover, shrink-to-fit=no'
  );
  document.head.prepend(m);
}

const root = document.querySelector<HTMLDivElement>('#app');
if (!root) throw new Error('#app missing');

// file:// 환경에서 ImageBitmap 업로드가 SecurityError 를 유발할 수 있어 비활성화
if (globalThis.location?.protocol === 'file:') {
  PIXI.settings.CREATE_IMAGE_BITMAP = false;
}

const canvas = document.createElement('canvas');
canvas.style.display = 'block';
canvas.setAttribute('aria-label', '미니언즈 사다리 게임');
root.appendChild(canvas);

new MinionsApp(canvas);
